import {Directive, ElementRef, HostListener, Renderer2} from '@angular/core';

@Directive({
  selector: '[armEllipsisTooltip]'
})
export class ArmEllipsisTooltipDirective {

  constructor(private elementRef: ElementRef, private  renderer: Renderer2) {}

  @HostListener('mouseover', ['$event'])
  setTooltip(): void {
    const element = this.elementRef.nativeElement;
    if (element.offsetWidth < element.scrollWidth){
      this.renderer.setAttribute(element, 'title', element.textContent);
    }else{
      this.renderer.removeAttribute(element, 'title');
    }
  }
}
